<template>
  <b-card class="rounded-0">
    <div class="d-flex">
      <b-form-group label="Company Name" class="mr-2">
        <b-form-input></b-form-input>
      </b-form-group>
      <b-form-group label="Submitted By">
        <b-form-select>
          <option
            v-for="submittedBy in submittedByArr"
            :key="submittedBy.id"
            :value="submittedBy.id"
          >
            {{ submittedBy.fullName }}
          </option>
        </b-form-select>
      </b-form-group>
    </div>

    <grid
      has-edit 
      :fields="fields" 
      :items="companies"
      @edit="clickEditGrid"  
    />
  </b-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import gridFields from '../../fields';

import Grid from '@/shared/components/Grid';

export default {
  components: {
    Grid,
  },
  data() {
    return {
      fields: gridFields,
    }
  },
  computed: {
    ...mapState('companies', [
      'companies',
      'submittedByArr',
    ]),
  },
  methods: {
    ...mapActions('companies', [
      'getCompanies',
      'getSubmittedBy',
    ]),
    clickEditGrid(company) {
      this.$router.push(`/companies/${company.id}`);
    },
  },
  async created() {
    await this.getCompanies();
    await this.getSubmittedBy();
  },
}
</script>